import { Disclosure } from '@headlessui/react'
import Link from 'next/link'
import { useEffect } from 'react'
import { NAV_DEF } from './consts'
import { useEmployeeAuth } from '../../hooks/useEmployeeAuth'

export const MobileNav = ({ open }) => {
  const { isAuthenticated: isEmployeeAuthenticated } = useEmployeeAuth()

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto'
  }, [open])
  return (
    <Disclosure.Panel
      className="overflow-auto"
      style={{ maxHeight: 'calc(90vh - 6rem)' }}
    >
      {[...NAV_DEF.values()].map((subnav, i) => (
        <Disclosure
          as="div"
          key={subnav.name}
          className="grid text-white px-4 pb-4 pt-2"
        >
          <Disclosure.Button
            as="h2"
            className="text-xl font-medium text-blue-light font-[sans-serif]"
          >
            {subnav.name}
          </Disclosure.Button>
          <Disclosure.Panel>
            <div className="col-span-2 md:col-span-1 px-4 md:px-16">
              <div className="">
                {subnav?.sections
                  .filter(
                    item => !item.employeeOnly || isEmployeeAuthenticated
                  )
                  .map(item => (
                  <div className="flex py-4" key={item.name}>
                    <img
                      type="image/svg+xml"
                      data="briefcase.svg"
                      className="h-8 w-auto"
                    />
                    <div className="px-8 inline-block">
                      <Link href={item.link}>
                        <div className="inline-block">
                          <h3 className="inline-block text-xl text-blue-light font-[sans-serif]">
                            {item.name}
                          </h3>
                        </div>
                      </Link>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-span-2 md:col-span-1 px-4 md:px-16 font-[sans-serif]">
              <h2 className="text-xl font-medium text-blue-light">
                Related Resource
              </h2>
              <div className="flex py-4 items-center">
                <div className="pr-8 inline-block">
                  <Link href="#" className="inline-block">
                    <h3 className="inline-block text-xl text-blue-light">
                      {subnav.related.name}
                    </h3>
                  </Link>
                  <p>{subnav.related.description}</p>
                </div>
                <Link href={subnav.related.link}>
                  <div className="px-4 py-2 w-200 text-sm bg-transparent text-blue-light border-2 border-blue-light inline-block text-center mt-4">
                    Learn More
                  </div>
                </Link>
              </div>
            </div>
          </Disclosure.Panel>
        </Disclosure>
      ))}
      <Link href="/contact-us">
        <button className="text-xl font-medium text-blue-light pl-4 pb-4 font-[sans-serif]">
          Contact
        </button>
      </Link>
    </Disclosure.Panel>
  )
}
